import apiClient from "../../apiClient";
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// get kitchen list
export const getFSKitchenList = async (fs_feature_id: number) => {
    try {
        const response = await apiClient.get(`/api/fs-kitchen-list/${fs_feature_id}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// get kitchen collection list
export const getFSKitchenCollectionList = async () => {
    try {
        const response = await apiClient.get(`/api/fs-kitchen-collection-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// get kitchen finish list
export const getFSKitchenFinishList = async () => {
    try {
        const response = await apiClient.get(`/api/fs-kitchen-finish-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// delete kitchen data
export const fsKitchenDelete = async (
    id: number
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(
            `${baseURL}/api/fs-kitchen-data/delete/${id}`,
            {
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                    Authorization: FULL_TOKEN,
                },
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};


/* ************************************************** Kitchen appliances */
// create kitchen appliance
export const fsKitchenApplianceCreate = async (
    fs_data_id: number,
    brand_id: number,
    appliance_id: number,
    color_id: number,
    name: string,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("appliance_id", String(appliance_id));
        formData.append("color_id", String(color_id));
        formData.append("name", name);

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-appliance/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen appliance
export const fsKitchenApplianceUpdate = async (
    id: number,
    brand_id: number,
    appliance_id: number,
    color_id: number,
    name: string,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("appliance_id", String(appliance_id));
        formData.append("color_id", String(color_id));
        formData.append("name", name);

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-appliance/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen type */
// create kitchen type
export const fsKitchenTypeCreate = async (
    fs_data_id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-type/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen type
export const fsKitchenTypeUpdate = async (
    id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-type/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        console.log('data', data)

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen base unit */
// create kitchen base unit
export const fsKitchenBaseUnitCreate = async (
    fs_data_id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-base-unit/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen base unit
export const fsKitchenBaseUnitUpdate = async (
    id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-base-unit/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        console.log('data', data)

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen wall unit */
// create kitchen wall unit
export const fsKitchenWallUnitCreate = async (
    fs_data_id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-wall-unit/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen wall unit
export const fsKitchenWallUnitUpdate = async (
    id: number,
    brand_id: number,
    collection_id: number,
    range_id: number,
    color_id: number,
    style_id: number,
    finish_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("collection_id", String(collection_id));
        formData.append("range_id", String(range_id));
        formData.append("color_id", String(color_id));
        formData.append("style_id", String(style_id));
        formData.append("finish_id", String(finish_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-wall-unit/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen worktop */
// create kitchen worktop
export const fsKitchenWorktopCreate = async (
    fs_data_id: number,
    brand_id: number,
    type_id: number,
    name: string,
    size_depth: number,
    size_thickness: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("type_id", String(type_id));
        formData.append("name", name);
        formData.append("size_depth", String(size_depth));
        formData.append("size_thickness", String(size_thickness));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-worktop/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen worktop
export const fsKitchenWorktopUpdate = async (
    id: number,
    brand_id: number,
    type_id: number,
    name: string,
    size_depth: number,
    size_thickness: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("type_id", String(type_id));
        formData.append("name", name);
        formData.append("size_depth", String(size_depth));
        formData.append("size_thickness", String(size_thickness));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-worktop/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen door */
// create kitchen door
export const fsKitchenDoorCreate = async (
    fs_data_id: number,
    brand_id: number,
    color_id: number,
    name: string,
    style_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("color_id", String(color_id));
        formData.append("name", name);
        formData.append("style_id", String(style_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-door/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen door
export const fsKitchenDoorUpdate = async (
    id: number,
    brand_id: number,
    color_id: number,
    name: string,
    style_id: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("color_id", String(color_id));
        formData.append("name", name);
        formData.append("style_id", String(style_id));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-door/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */


/* ************************************************** Kitchen handle */
// create kitchen handle
export const fsKitchenHandleCreate = async (
    fs_data_id: number,
    brand_id: number,
    name: string,
    number: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;

        const formData = new FormData();
        formData.append("fs_data_id", String(fs_data_id));
        formData.append("brand_id", String(brand_id));
        formData.append("name", name);
        formData.append("number", String(number));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-handle/create`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};

// update kitchen handle
export const fsKitchenHandleUpdate = async (
    id: number,
    brand_id: number,
    name: string,
    number: number,
    link: string | null,
    image_path: File | null,
    file_list: File[] | null
): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem("token");
        const FULL_TOKEN = `Bearer ${token}`;
        const formData = new FormData();

        formData.append("brand_id", String(brand_id));
        formData.append("name", name);
        formData.append("number", String(number));

        if (link !== null) {
            formData.append("link", link);
        }

        if (image_path !== null) {
            formData.append("image_path", image_path);
        }

        if (file_list !== null) {
            file_list.forEach((file, index) => {
                formData.append("file_list[]", file);
            });
        }

        const response = await fetch(`${baseURL}/api/fs-kitchen-handle/update/${id}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: FULL_TOKEN,
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }
    } catch (error) {
        throw error;
    }
};
/* ************************************************** */
